/* eslint-disable react/jsx-pascal-case */
import {
    Row,
    Col,
    Button,
    Form,
    Input,
    Typography,
    Textarea,
    Switch,
    Select,
    message,
    Radio,
    JoditEditor
} from "../../ui/ot";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
import { usePermission } from "../controller/PermissionController";
import { useMenu } from "../controller/menu_controller";
import Divider from "../../ui/divider";
import News from "../../news/views/News";
import { ArrowUp, ArrowDown, Trash2, Eye, EyeOff, Spline } from "lucide-react";
import { usePageManagement } from "../controller/page_management_controller";
import ArticleSelectModal from './article_select_modal'
import UploadImg from "../UploadImg";
import axios from 'axios';
// import MultipleSelector from '../../ui/multiple-selector'
const PageBlogForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    editcard,
    propertyJsonShow = null,
}) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0);
    const [blogFieldId, setBlogFieldId] = useState();
    const youtubeDetectRef = useRef(setTimeout(() => { }, 0));
    const [modalOpen, setModalOpen] = useState(false);
    const [show, setShow] = useState(true)
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getPermissionChildrenData({
            classify_structure_id: 5,
            // classify_structure_type_id: 0,
        });
        getPageManagementData({});
        getMenuData({});
        if (editcard) {
        }
    };
    const onFinish = (values) => {
        setShow(false)
        setTimeout(() => {
            let formValues = null;
            if (propsForm) {
                formValues = propsForm.getFieldsValue();
            } else {
                formValues = form.getFieldsValue();
            }
            onFormFinish({
                ...formValues,
            });
        }, 2000);
        setShow(true)
    };
    const onValuesChange = (value, { name, type }) => {

        let changeFormName = (name || "").split(".");
        if (changeFormName.includes("title")) {
            setCount((pre) => pre + 1);
        }
        else if (
            changeFormName.includes(
                "extermal_link_check_replace" ||
                changeFormName.includes(
                    "blog_type_classify_structure_type_blog_data"
                )
            )
        ) {
            setCount((pre) => pre + 1);
        }
        else if (changeFormName.includes("youtube_iframe")) {
            clearTimeout(youtubeDetectRef.current);
            youtubeDetectRef.current = setTimeout(onYoutubeDetect(name), 1000);
        }
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // setFormValuesOtherThings(formValues);
    };
    const onYoutubeDetect = (name) => {
        let value = '';
        if (!!propsForm) {
            value = propsForm.getFieldValue(
                name
            );
        } else {
            value = form.getFieldValue(
                name
            );
        }
        let youtube_iframe = value
        let element = "";
        if (youtube_iframe !== "") {
            let stringhtml = youtube_iframe;
            let parser = new DOMParser();
            let parsedResult = parser.parseFromString(
                stringhtml,
                "text/html"
            );
            element = parsedResult.getElementsByTagName("iframe");
            for (let index = 0; index < element.length; index++) {
                const item = element[index];

                item.setAttribute("width", "100%");
                item.setAttribute("height", "100%");
            }
        }
        setFieldValue(name, element[0]?.outerHTML);
    };
    const getLanguageLabel = (language_culture_code) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        return label[language_culture_code];
    };
    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || "";
    };

    const { getMenuData, MenuData } = useMenu({
        onBefore: () => { },
        onFinish: () => { },
    });

    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
        setCount((pre) => pre + 1);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }

        return formValues;
    };

    // 手動解析字串並更新值的函數
    function setValueByPath(obj, path, value) {
        const keys = path.split(".");
        let current = obj;
        keys.forEach((key, index) => {
            if (key.includes("[")) {
                const [arrayKey, arrayIndex] = key
                    .split(/[\[\]]/)
                    .filter(Boolean);
                if (index === keys.length - 1) {
                    current[arrayKey][parseInt(arrayIndex)] = value;
                } else {
                    current = current[arrayKey][parseInt(arrayIndex)];
                }
            } else {
                if (index === keys.length - 1) {
                    current[key] = value;
                } else {
                    current = current[key];
                }
            }
        });
        return obj;
    }



    const { getPermissionChildrenData, permissionChildrenData } = usePermission(
        {
            onBefore: () => { },
            onFinish: () => { },
        }
    );
    const { PageManagementData, getPageManagementData } = usePageManagement({
        onFinish: () => { },
        onBefore: () => { },
    });
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);


    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={{}}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={12} hidden={true}>
                            <Form.Item
                                labelCol={6}
                                wrapperCol={18}
                                label={"blog_type_id"}
                                hidden={true}
                                name={"blog_type_id"}
                            >
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                labelCol={6}
                                wrapperCol={18}
                                label={"標題"}
                                name={"blog_type_name"}
                            >
                                <Input></Input>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 18 }}
                                label="隱藏標題"
                                name="blog_type_hidden_name"
                            >
                                <Radio.Group>
                                    <Radio value={true}>是</Radio>
                                    <Radio value={false}>否</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Divider>
                                <Typography.Title level={3}>
                                    貼文設定
                                </Typography.Title>
                            </Divider>
                        </Col>

                        <Col span={24}>
                            <Row>
                                <Col span={24}>
                                    <Form.List
                                        name={"frontend_column_frontend_component_blog_type_blog_data"}
                                    >
                                        {(fields, { add, remove, move, swap }) => (
                                            <Row gutter={[8, 8]}>
                                                <Col span={24}>
                                                    <Row gutter={[8, 8]}>
                                                        <Col>
                                                            <Button
                                                                onClick={() => {
                                                                    add({
                                                                        title: "",
                                                                        extermal_link_check_replace: false,
                                                                        extermal_link_check: 0
                                                                    });
                                                                }}
                                                            >
                                                                新增貼文
                                                            </Button>
                                                        </Col>
                                                        <Col>
                                                            <ArticleSelectModal
                                                                propsOpen={modalOpen}
                                                                propsSetOpen={setModalOpen}
                                                                articleTableProps={
                                                                    {
                                                                        showAllColumns: false,
                                                                        propsShowColumns: ['title', 'blog_category_data'],
                                                                        mode: "view",
                                                                        rowSelectType: 'checkbox',
                                                                        // defaultSelectkeys: [],
                                                                        // defaultSelectInfos: [],

                                                                    }
                                                                }
                                                                onFinish={(selectInfos) => {
                                                                    selectInfos.forEach((element) => {
                                                                        let editRecord = { ...element }
                                                                        editRecord = {
                                                                            ...editRecord,
                                                                            blog_category_data: editRecord?.blog_category_data.map((value) => {
                                                                                return value?.category_id
                                                                            }),
                                                                            extermal_link_check_replace: editRecord['extermal_link_check'] === 1
                                                                        }
                                                                        delete editRecord.blog_category_data
                                                                        add({
                                                                            ...editRecord
                                                                        })
                                                                    })
                                                                    message.success("帶入成功");
                                                                    setModalOpen(false)

                                                                }}

                                                            />
                                                            <Button
                                                                onClick={() => {
                                                                    setModalOpen(true)
                                                                }}
                                                            >
                                                                帶入歷史貼文
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row>
                                                        <Col span={6}>
                                                            <Row
                                                                gutter={[4, 4]}
                                                            >
                                                                {fields.map(
                                                                    (field, inx) => {
                                                                        return (
                                                                            <Col span={24}>
                                                                                <Row>
                                                                                    <Col span={20}>

                                                                                        <Button
                                                                                            onClick={() => {
                                                                                                setBlogFieldId(
                                                                                                    field.id
                                                                                                );
                                                                                            }}
                                                                                            type={
                                                                                                field.id ===
                                                                                                    blogFieldId
                                                                                                    ? "secondary"
                                                                                                    : "default"
                                                                                            }
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                whiteSpace: "nowrap",      // 確保文字不換行
                                                                                                overflow: "hidden",        // 隱藏超出範圍的文字
                                                                                                textOverflow: "ellipsis",  // 在文字結尾顯示...
                                                                                                display: "block",          // 確保按鈕內的內容顯示為塊級元素
                                                                                            }}
                                                                                        >
                                                                                            {`【排序${inx +
                                                                                                1
                                                                                                }】`}
                                                                                            {getAnyFormValue(
                                                                                                `${field.name}.title`,
                                                                                                count
                                                                                            ) ||
                                                                                                "請填寫貼文標題"}
                                                                                        </Button>
                                                                                    </Col>
                                                                                    <Col
                                                                                        // hidden={true}
                                                                                        span={
                                                                                            4
                                                                                        }
                                                                                    >
                                                                                        <Row
                                                                                        // wrap={
                                                                                        //     false
                                                                                        // }
                                                                                        >
                                                                                            <Col>
                                                                                                <Button
                                                                                                    key={field.id}
                                                                                                    disabled={inx === 0}
                                                                                                    size="sm"
                                                                                                    variant={
                                                                                                        "secondary"
                                                                                                    }
                                                                                                    onClick={() => {
                                                                                                        move(
                                                                                                            inx,
                                                                                                            inx -
                                                                                                            1
                                                                                                        );
                                                                                                    }}
                                                                                                    style={{
                                                                                                        padding:
                                                                                                            "2px",
                                                                                                    }}
                                                                                                >
                                                                                                    <ArrowUp
                                                                                                        size={
                                                                                                            16
                                                                                                        }
                                                                                                    />
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <Button
                                                                                                    key={field.id}
                                                                                                    disabled={
                                                                                                        inx === fields.length - 1
                                                                                                    }
                                                                                                    size="sm"
                                                                                                    // type="text"
                                                                                                    variant={"secondary"}
                                                                                                    style={{ padding: "2px", }}
                                                                                                    onClick={() => {
                                                                                                        move(inx, inx + 1);
                                                                                                    }}
                                                                                                >
                                                                                                    <ArrowDown
                                                                                                        size={16}
                                                                                                    />
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <Button
                                                                                                    key={field.id}
                                                                                                    size="sm"
                                                                                                    type="danger"

                                                                                                    style={{ padding: "2px", }}
                                                                                                    onClick={() => {

                                                                                                        remove(inx);
                                                                                                    }}
                                                                                                >
                                                                                                    <Trash2
                                                                                                        size={16}
                                                                                                    />
                                                                                                </Button>
                                                                                            </Col>
                                                                                            {/* <Col>
                                                                                                <Button
                                                                                                    style={{ padding: "2px", }}
                                                                                                    size="sm"
                                                                                                    onClick={() => {
                                                                                                        setFieldValue(`${field.name}.show`, !(Boolean(getAnyFormValue(`${field.name}.show`, count))))
                                                                                                    }}
                                                                                                    type={
                                                                                                        Boolean(getAnyFormValue(`${field.name}.show`, count)) ===
                                                                                                            true
                                                                                                            ? "primary"
                                                                                                            : "danger"
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        Boolean(getAnyFormValue(`${field.name}.show`, count)) ? (
                                                                                                            <Eye
                                                                                                                size={16}
                                                                                                            />
                                                                                                        ) : (
                                                                                                            <EyeOff
                                                                                                                size={16}
                                                                                                            />
                                                                                                        )
                                                                                                    }
                                                                                                </Button>
                                                                                            </Col> */}
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        );
                                                                    }
                                                                )}
                                                            </Row>
                                                        </Col>
                                                        <Col span={18}>
                                                            {fields.map(
                                                                (
                                                                    field,
                                                                    fieldIndex
                                                                ) => {
                                                                    return (

                                                                        <Col
                                                                            key={field.id}
                                                                            hidden={field.id !== blogFieldId}
                                                                            span={24}
                                                                        >
                                                                            <Row>
                                                                                <Col span={24} >
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label="blog_id"
                                                                                        name={[field.name, "blog_id"]}
                                                                                        hidden={true}
                                                                                    >

                                                                                        <div
                                                                                            key={field.id}
                                                                                        ></div>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col span={24} >
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label="blog_index"
                                                                                        name={[field.name, "blog_index"]}
                                                                                        hidden={true}
                                                                                    >

                                                                                        <div
                                                                                            key={field.id}
                                                                                        ></div>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    span={24}
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label="貼文標題"
                                                                                        name={[field.name, "title",]}
                                                                                        hidden={
                                                                                            !propertyJsonShow
                                                                                                ? false
                                                                                                : !propertyJsonShow[
                                                                                                "title"
                                                                                                ]
                                                                                        }
                                                                                    >
                                                                                        <Input
                                                                                            key={field.id}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label="貼文內容"
                                                                                        name={[
                                                                                            field.name,
                                                                                            "content",
                                                                                        ]}
                                                                                        hidden={
                                                                                            !propertyJsonShow
                                                                                                ? false
                                                                                                : !propertyJsonShow[
                                                                                                "content"
                                                                                                ]
                                                                                        }
                                                                                    >
                                                                                        <Textarea
                                                                                            key={field.id}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col span={24}>
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label={
                                                                                            "連結設定"
                                                                                        }
                                                                                        name={[
                                                                                            field.name,
                                                                                            "extermal_link_check",
                                                                                        ]}
                                                                                        valuePropName="checked"
                                                                                        hidden={
                                                                                            true
                                                                                        }
                                                                                    >
                                                                                        <Input

                                                                                            key={field.id}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label={
                                                                                            "連結設定"
                                                                                        }
                                                                                        name={[
                                                                                            field.name,
                                                                                            "extermal_link_check_replace",
                                                                                        ]}
                                                                                        valuePropName="checked"
                                                                                        hidden={
                                                                                            !propertyJsonShow
                                                                                                ? false
                                                                                                : !propertyJsonShow[
                                                                                                "extermal_link_check"
                                                                                                ]
                                                                                        }
                                                                                    >
                                                                                        <Switch
                                                                                            key={field.id}
                                                                                            checkedChildren="外部連結"
                                                                                            unCheckedChildren="內部連結"
                                                                                            onChange={(e) => {

                                                                                                let newValue = e.target.value ? 1 : 0

                                                                                                setFieldValue(`${field.name}.extermal_link_check`, newValue)
                                                                                            }}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={4}
                                                                                        wrapperCol={20}
                                                                                        label={
                                                                                            getAnyFormValue(
                                                                                                `${field?.name}.extermal_link_check_replace`,
                                                                                                count
                                                                                            )
                                                                                                ? "外部連結"
                                                                                                : "內部連結"
                                                                                        }
                                                                                        name={[
                                                                                            field.name,
                                                                                            "external_link",
                                                                                        ]}
                                                                                        hidden={
                                                                                            !propertyJsonShow
                                                                                                ? false
                                                                                                : !propertyJsonShow[
                                                                                                "external_link"
                                                                                                ]
                                                                                        }
                                                                                    >
                                                                                        {getAnyFormValue(
                                                                                            `${field?.name}.extermal_link_check_replace`,
                                                                                            count
                                                                                        ) ? (
                                                                                            <Input
                                                                                                key={field.id}
                                                                                            />
                                                                                        ) : (
                                                                                            <Select
                                                                                                placeholder="請選擇連結頁面"
                                                                                                key={field.id}
                                                                                                options={(
                                                                                                    PageManagementData ||
                                                                                                    []
                                                                                                ).map(
                                                                                                    (
                                                                                                        value
                                                                                                    ) => {
                                                                                                        return {
                                                                                                            label: getLanguageName(
                                                                                                                {
                                                                                                                    language_culture_code:
                                                                                                                        "zh-tw",
                                                                                                                    obj_language_data:
                                                                                                                        value?.name_language_data,
                                                                                                                }
                                                                                                            ),
                                                                                                            value: value?.page_id,
                                                                                                        };
                                                                                                    }
                                                                                                )}

                                                                                            />
                                                                                        )}
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    span={24}
                                                                                    hidden={true}

                                                                                >
                                                                                    <Form.List
                                                                                        hidden={true}
                                                                                        name={`${field.name}.blog_type_classify_structure_type_blog_data`}
                                                                                    >
                                                                                        {(
                                                                                            subfields,
                                                                                            {
                                                                                                add: testAdd,
                                                                                            }
                                                                                        ) => (
                                                                                            <Row

                                                                                            >
                                                                                                <Col
                                                                                                    span={
                                                                                                        24
                                                                                                    }
                                                                                                >
                                                                                                    {subfields.map(
                                                                                                        (
                                                                                                            subfield
                                                                                                        ) => {
                                                                                                            return (
                                                                                                                <Row>
                                                                                                                    <Col
                                                                                                                        span={
                                                                                                                            8
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <Form.Item
                                                                                                                            label="file_id"
                                                                                                                            hidden={true}
                                                                                                                            name={`${subfield.name}.file_id`}
                                                                                                                        >
                                                                                                                            <Input />
                                                                                                                        </Form.Item>
                                                                                                                    </Col>
                                                                                                                    <Col
                                                                                                                        span={
                                                                                                                            8
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <Form.Item
                                                                                                                            label="file_url"
                                                                                                                            hidden={true}
                                                                                                                            name={`${subfield.name}.file_url`}
                                                                                                                        >
                                                                                                                            <Input />
                                                                                                                        </Form.Item>
                                                                                                                    </Col>
                                                                                                                    <Col
                                                                                                                        span={
                                                                                                                            8
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <Form.Item
                                                                                                                            label="file"
                                                                                                                            name={`${subfield.name}.file`}
                                                                                                                            hidden={true}

                                                                                                                        >
                                                                                                                            <Input />
                                                                                                                        </Form.Item>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            );
                                                                                                        }
                                                                                                    )}
                                                                                                </Col>
                                                                                                <Col
                                                                                                    span={
                                                                                                        24
                                                                                                    }
                                                                                                >
                                                                                                    <Form.Item
                                                                                                        labelCol={
                                                                                                            4
                                                                                                        }
                                                                                                        wrapperCol={
                                                                                                            20
                                                                                                        }
                                                                                                        label={
                                                                                                            "上傳圖片"
                                                                                                        }
                                                                                                        name={`upload`}
                                                                                                    >
                                                                                                        <div />
                                                                                                    </Form.Item>


                                                                                                </Col>
                                                                                            </Row>
                                                                                        )}
                                                                                    </Form.List>
                                                                                </Col>
                                                                                <Col span={24}
                                                                                    hidden={
                                                                                        !propertyJsonShow
                                                                                            ? false
                                                                                            : !propertyJsonShow[
                                                                                            "blog_type_classify_structure_type_blog_data"
                                                                                            ]
                                                                                    }
                                                                                >
                                                                                    <UploadImg
                                                                                        defaultValue={getAnyFormValue(`${field.name}.blog_type_classify_structure_type_blog_data`, count)}
                                                                                        onImagesChange={(value) => {
                                                                                            setFieldValue(`${field.name}.blog_type_classify_structure_type_blog_data`, value)
                                                                                        }}
                                                                                    />
                                                                                </Col>
                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={
                                                                                            4
                                                                                        }
                                                                                        wrapperCol={
                                                                                            20
                                                                                        }
                                                                                        label={
                                                                                            "Youtube連結"
                                                                                        }
                                                                                        name={[
                                                                                            field.name,
                                                                                            "youtube_iframe",
                                                                                        ]}
                                                                                        hidden={
                                                                                            !propertyJsonShow
                                                                                                ? false
                                                                                                : !propertyJsonShow[
                                                                                                "youtube_iframe"
                                                                                                ]
                                                                                        }
                                                                                    >
                                                                                        <Textarea></Textarea>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    hidden={
                                                                                        true
                                                                                    }
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.List
                                                                                        name={`${field.name}.blog_news_data`}
                                                                                        // hidden={ !propertyJsonShow ? false : !propertyJsonShow[ "blog_news_data" ]  }
                                                                                        hidden={true}
                                                                                    >
                                                                                        {(
                                                                                            newsFields
                                                                                        ) => (
                                                                                            // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                                                                            <>
                                                                                                {newsFields.map((
                                                                                                    newsField
                                                                                                ) => (
                                                                                                    <>
                                                                                                        <Form.Item
                                                                                                            // hidden
                                                                                                            name={[
                                                                                                                newsField.name,
                                                                                                                "news_id",
                                                                                                            ]}
                                                                                                        >
                                                                                                            <Input />
                                                                                                        </Form.Item>
                                                                                                    </>
                                                                                                )
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </Form.List>
                                                                                </Col>
                                                                                {/* <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={
                                                                                            0
                                                                                        }
                                                                                        wrapperCol={
                                                                                            24
                                                                                        }
                                                                                        // hidden={ !propertyJsonShow ? false : !propertyJsonShow[ "blog_news_data" ]  }
                                                                                        hidden={true}
                                                                                        name={[
                                                                                            field.name,
                                                                                            "blog_news_data",
                                                                                        ]}
                                                                                    >
                                                                                        <News
                                                                                            defaultSize={
                                                                                                10
                                                                                            }
                                                                                            showSwitch={
                                                                                                true
                                                                                            }
                                                                                            propsShowColumns={[
                                                                                                "news_title",
                                                                                                "staff_name",
                                                                                                "news_type_name",
                                                                                                "news_time",
                                                                                                "announce_time_end",
                                                                                                "news_id",
                                                                                                "option",
                                                                                            ]}
                                                                                            propsCheckSelectRowKeys={(
                                                                                                getAnyFormValue(
                                                                                                    `${field.name}.blog_news_data`
                                                                                                ) ||
                                                                                                []
                                                                                            ).map(
                                                                                                (
                                                                                                    value
                                                                                                ) =>
                                                                                                    value?.news_id
                                                                                            )}
                                                                                            propsCheckSelectedRowsInfo={[]}
                                                                                            propsMode={
                                                                                                false
                                                                                            }
                                                                                            showNewsType={
                                                                                                true
                                                                                            }
                                                                                            onCheckSelectChange={(
                                                                                                keys,
                                                                                                infos
                                                                                            ) => {
                                                                                                let newsIdData =
                                                                                                    keys.map(
                                                                                                        (
                                                                                                            val,
                                                                                                            index
                                                                                                        ) => {
                                                                                                            return {
                                                                                                                news_id:
                                                                                                                    val,
                                                                                                            };
                                                                                                        }
                                                                                                    );

                                                                                                setFieldValue(
                                                                                                    `${field.name}.blog_news_data`,
                                                                                                    newsIdData
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Col> */}
                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        labelCol={
                                                                                            4
                                                                                        }
                                                                                        wrapperCol={
                                                                                            20
                                                                                        }
                                                                                        label={
                                                                                            "直播字幕"
                                                                                        }
                                                                                        hidden={true}
                                                                                        // hidden={!propertyJsonShow ? false : !propertyJsonShow["blog_room_data"]}
                                                                                        name={[
                                                                                            field.name,
                                                                                            "blog_room_data",
                                                                                        ]}
                                                                                    >
                                                                                        <Switch
                                                                                            checkedChildren="開啟"
                                                                                            unCheckedChildren="關閉"
                                                                                            defaultChecked={getAnyFormValue(
                                                                                                `${field.name}.blog_room_data`,
                                                                                                count
                                                                                            )}
                                                                                            onChange={(
                                                                                                e
                                                                                            ) => {
                                                                                                if (
                                                                                                    e
                                                                                                ) {
                                                                                                    setFieldValue(
                                                                                                        `${field.name}.blog_room_data`,
                                                                                                        [
                                                                                                            {},
                                                                                                        ]
                                                                                                    );
                                                                                                } else
                                                                                                    setFieldValue(
                                                                                                        `${field.name}.blog_room_data`,
                                                                                                        []
                                                                                                    );
                                                                                            }}
                                                                                        />
                                                                                    </Form.Item>
                                                                                    <Form.List
                                                                                        name={`${field.name}.blog_room_data`}
                                                                                    >
                                                                                        {(
                                                                                            subRoomFields,
                                                                                            subRoomOpt
                                                                                        ) => (
                                                                                            // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                                                                            <>
                                                                                                {subRoomFields.map(
                                                                                                    (
                                                                                                        subRoomField
                                                                                                    ) => (
                                                                                                        <>
                                                                                                            <Form.Item
                                                                                                                hidden
                                                                                                                name={[
                                                                                                                    subRoomField.name,
                                                                                                                    "blog_room_id",
                                                                                                                ]}
                                                                                                            >
                                                                                                                <Input />
                                                                                                            </Form.Item>
                                                                                                            <Form.Item
                                                                                                                hidden
                                                                                                                name={[
                                                                                                                    subRoomField.name,
                                                                                                                    "room_id",
                                                                                                                ]}
                                                                                                            >
                                                                                                                <Input />
                                                                                                            </Form.Item>
                                                                                                        </>
                                                                                                    )
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </Form.List>
                                                                                </Col>
                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Form.Item
                                                                                        label={
                                                                                            "詳細內容"
                                                                                        }
                                                                                        labelCol={
                                                                                            4
                                                                                        }
                                                                                        wrapperCol={
                                                                                            20
                                                                                        }
                                                                                        hidden={
                                                                                            !propertyJsonShow
                                                                                                ? false
                                                                                                : !propertyJsonShow[
                                                                                                "more_content"
                                                                                                ]
                                                                                        }
                                                                                        name={[
                                                                                            field.name,
                                                                                            "more_content",
                                                                                        ]}
                                                                                    >
                                                                                        {field.id === blogFieldId ? (
                                                                                            show ?
                                                                                                <Editor
                                                                                                    key={field.id}
                                                                                                    hidden={field.id !== blogFieldId}
                                                                                                    // propsValue={
                                                                                                    //     getAnyFormValue(`${field.name}.more_content`,count)
                                                                                                    // }
                                                                                                    // value={getAnyFormValue(
                                                                                                    //     `${field.name}.more_content`,
                                                                                                    //     count
                                                                                                    // )}
                                                                                                    propsValue={getAnyFormValue(
                                                                                                        `${field.name}.more_content`,
                                                                                                        count
                                                                                                    )}
                                                                                                    // name={`${field.name}.more_content`}

                                                                                                    onContentChange={(
                                                                                                        val
                                                                                                    ) => {
                                                                                                        setFieldValue(
                                                                                                            `${field.name}.more_content`,
                                                                                                            `${val}`
                                                                                                        );
                                                                                                    }}
                                                                                                /> : <Input disabled />
                                                                                        ) : undefined}
                                                                                    </Form.Item>
                                                                                </Col>

                                                                                <Col
                                                                                    span={
                                                                                        24
                                                                                    }
                                                                                >
                                                                                    <Divider>

                                                                                    </Divider>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    );
                                                                }
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        )}
                                    </Form.List>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
};
const Editor = ({ propsValue = null, onContentChange = () => { }, hidden = false }) => {
    const [form] = Form.useForm();
    const [content, setContent] = useState("");
    const editor = useRef(null);
    const testref = useRef(propsValue)
    const config = {
        // readonly: false, // all options from https://xdsoft.net/jodit/doc/
        // uploader: {
        //     insertImageAsBase64URI: true,
        //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        // },
        // language: 'zh_tw'
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: "zh_tw",
        onChangePeriod: 1000,
        i18n: {
            zh_tw: {
                Default: "預設",
                "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.":
                    "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                Anchor: "Anchor",
                Margins: "外邊距（Margins）",
                top: "top",
                right: "right",
                bottom: "bottom",
                left: "left",
                Classes: "Classes",
                Src: "Src",
                Title: "Title",
                Link: "Link",
                file: "file",
                "Image properties": "圖片屬性",
                "Your code is similar to HTML. Keep as HTML?":
                    "你黏貼的文本是一段html代碼，是否保留源格式",
                "Paste as HTML": "html黏貼",
                "Insert as Text": "把html代碼視為普通文本",
                "Error on load list": "加載list錯誤",
                Break: "Pause",
                "No follow": "No follow",
                URL: "URL",
                Crop: "Crop",
                Default: "默認",
                Circle: "圓圈",
                Dot: "點",
                Quadrate: "方形",
                Find: "搜尋",
                "Insert className": "插入標籤名稱",
                "Press Alt for custom resizing": "按Alt自定義調整大小",
                "Find Next": "找下一個",
                "Find Previous": "找上一個",
                replace: "替代",
                "Line height": "行高",
            },
        },
        uploader: {
            insertImageAsBase64URI: false,
            imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
            url: `${axios.defaults.baseURL}/component/file`, // This won't be used since we're using 
            format: 'json',
            headers: {
                authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },

            prepareData: function (formdata) {
                formdata.append('inputFile', formdata.get('files[0]')); // $_POST['name'] on server
                return formdata
            },
            isSuccess: function (resp) {
                return resp.hasOwnProperty('file_id');
            },
            process: function (resp) {
                let filename = resp?.file_client_name || '';
                let ext = filename.split('.').pop().toLowerCase();
                let imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
                let isImage = imageExtensions.includes(ext);
                return {
                    "baseurl": `${axios.defaults.baseURL}/component/file?file_id=${resp?.file_id}`,
                    "messages": [
                        ""
                    ],
                    "files": [''],
                    "isImages": [
                        !!isImage
                    ],
                    "code": 200
                };
            },
            getMessage: function (resp) {
                return resp.hasOwnProperty('file_id') ? '上傳成功' : '上傳失敗'
            },
        },
    };

    const onChange = (content) => {
        testref.current = content
    };

    useEffect(() => {
        document.body.style.pointerEvents = "auto";
        setContent(propsValue);
    }, [propsValue]);
    useEffect(() => {
        return () => {
            onContentChange(testref.current)
        }
    }, [])
    return (
        <JoditEditor
            propsHidden={hidden}
            ref={editor}
            value={content}
            onChange={(e) => { onChange(e) }}
            config={config}
            tabIndex={1} // tabIndex of textarea
            height={1000}
            allowResizeX={true}
            allowResizeY={true}
        />
    );
};
export default PageBlogForm;

